import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { memo } from "react";

const DocViewerHelperComponent = ({
  url,
  fileType,
  previewContentHeightClasses,
  isMobile,
}: {
  url: string;
  fileType: string;
  previewContentHeightClasses: string;
  isMobile: boolean;
}) => {
  return (
    <DocViewer
      pluginRenderers={DocViewerRenderers}
      documents={[
        {
          uri: url,
          fileType,
        },
      ]}
      config={{
        header: {
          disableHeader: true,
          disableFileName: true,
          retainURLParams: false,
        },
        pdfVerticalScrollByDefault: true,
      }}
      className="h-full"
      style={{
        height: previewContentHeightClasses,
        overflow: "scroll",
        maxWidth: isMobile ? "95%" : "80%",
      }}
    />
  );
};

export const DocViewerHelper = memo(DocViewerHelperComponent);
